import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import NavBar from "./components/Navbar";
import { lightTheme } from "./theme/theme";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core/";
import Home from "./pages/home";
import Gutter from "./components/Gutter";
import About from "./pages/About";
import CodeOfConducts from "./pages/CodeOfConducts";
import Commuinty from "./pages/Commuinty";

function App() {
  return (
    <div style={{ minWidth: "320px" }}>
      <MuiThemeProvider theme={lightTheme}>
        <CssBaseline>
          <BrowserRouter>
            <NavBar />
            <Route path="/3688website/" exact>
              <Home />
            </Route>
            <Route path="/about" exact>
              <About />
            </Route>
            <Route path="/community" exact>
              <Commuinty />
            </Route>
            <Route path="/coe" exact>
              <CodeOfConducts />
            </Route>
            <Gutter />
          </BrowserRouter>
        </CssBaseline>
      </MuiThemeProvider>
    </div>
  );
}

export default App;
